export default "__VITE_ASSET__CzerUpBV__"